'use client';

import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { encodePassphrase, generateRoomId, randomString } from '@/lib/client-utils';
import styles from '../styles/Home.module.css';

export default function Page() {
  const router = useRouter();
  const [e2ee, setE2ee] = useState(false);
  const [sharedPassphrase] = useState(randomString(64));

  const startMeeting = () => {
    if (e2ee) {
      router.push(`/rooms/${generateRoomId()}#${encodePassphrase(sharedPassphrase)}`);
    } else {
      router.push(`/rooms/${generateRoomId()}`);
    }
  };

  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <div className="header">
          <h1 style={{ fontSize: '2.5rem', fontWeight: 700, margin: 0 }}>Видеовстречи</h1>
          <h2 style={{ marginTop: '0.5rem' }}>Создайте комнату и поделитесь ссылкой</h2>
        </div>
        <div className={styles.tabContent}>
          <p style={{ margin: 0 }}>Начните встречу одним кликом</p>
          <button style={{ marginTop: '1rem' }} className="lk-button" onClick={startMeeting}>
            Начать встречу
          </button>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem', marginTop: '1rem' }}>
            <input
              id="use-e2ee"
              type="checkbox"
              checked={e2ee}
              onChange={(ev) => setE2ee(ev.target.checked)}
            />
            <label htmlFor="use-e2ee">Сквозное шифрование</label>
          </div>
        </div>
      </main>
      <footer data-lk-theme="default" />
    </>
  );
}
